export default theme => ({
  textField: {
    width: '100%',
    marginBottom: '9px'
  },
  link: {
    color: theme.palette.primary.linkColor,
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  contentRow: {
    display: 'flex',
    maxWidth: '1100px'
  },
  groupRadio: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0'
  }
});
